/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import React from 'react';
import { ThemeProvider } from 'styled-components/macro';

import { darkTheme } from '../Theme';

const ArchitectSceneViewer = React.memo(() => (
  <ThemeProvider theme={darkTheme} />
));

export { ArchitectSceneViewer };
